import { mapActions, mapGetters } from "vuex"
import EventBus, { EVENTS } from "@/lib/event-bus"

import { isPresent } from "@/lib/utils"
import { nextPage, nextPageByOrder } from "@/lib/page-sequence"
import { REASONS } from "@/lib/page-access-shared"

export default {
  computed: {
    ...mapGetters("pages", ["getPageAccess"])
  },

  methods: {
    ...mapActions("pages", ["fetchPageAccess"]),

    handleNextPage(byOrder) {
      const page = byOrder
        ? nextPageByOrder({
            sequence: this.sequenceList,
            currentPageId: this.pageId
          })
        : nextPage(this.sequenceList)

      if (isPresent(page)) {
        const access = this.getPageAccess(page.page_id)

        if (isPresent(access)) {
          this.handleRedirectWithAccess(page, access)
        } else {
          this.fetchPageAccess(page.page_id).then(access => {
            this.handleRedirectWithAccess(page, access)
          })
        }
      }
    },

    handleRedirectWithAccess(page, access) {
      if (access.granted) {
        this.$router.push(page.path)
      } else if (access.data.reason === REASONS.REQUIRE_PURCHASE) {
        EventBus.$emit(EVENTS.TRIGGER_CHECKOUT, {
          productIds: access.data.product_ids,
          overlay: access.data.purchase_overlay
        })
      } else if (access.data.reason === REASONS.IS_SCHEDULED) {
        EventBus.$emit(EVENTS.TRIGGER_SCHEDULED_MODAL, page.page_id)
      }
      // TODO: Handle private pages
    }
  }
}
